"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Questions = (props) => {
    const { width, height } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32", testID: "Rewards" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "#0064CC", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h24v24H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M12 4.8c-3.97 0-7.2 3.23-7.2 7.2s3.23 7.2 7.2 7.2 7.2-3.23 7.2-7.2-3.23-7.2-7.2-7.2zm-.3 11.4a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8zm2.587-5.324c-.186.297-.538.63-1.058 1.002-.84.621-.817.76-.817 1.322h-1.475c0-.44-.01-.778.228-1.189.152-.263.43-.543.835-.84.485-.346.957-.68.957-1.263 0-.545-.467-.74-1.012-.74-.556 0-1.19.182-1.903.546l-.606-1.218c1.294-.725 3.336-1.054 4.453-.145.82.668.824 1.842.398 2.525z" }))));
};
Questions.defaultProps = {
    width: 32,
    height: 32,
};
exports.default = react_1.default.memo(Questions);
